import { Card, CardContent, CardFooter, CardHeader } from '@nesso/ui/primitives/card';
import { Skeleton } from '@nesso/ui/primitives/skeleton';

export function PickPlanCardSkeleton() {
    return (
        <Card>
            <CardHeader>
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-5 w-44" />
            </CardHeader>
            <CardContent className="flex items-center gap-3 py-4">
                <Skeleton className="h-9 w-20" />
            </CardContent>
            <CardFooter>
                <Skeleton className="h-9 w-full" />
            </CardFooter>
        </Card>
    );
}
